import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { currentFlowTypeEnum } from '../../common/components/constants';
import { getCreditTransactionForProgramInitiate } from '../../../actions/programs';
import GiftingProgramRecipientsTable from './GiftingProgramRecipientsTable';

const mapStateToProps = state => {
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD;
  const programCreditTransactions = _get(
    state,
    'programs.programCreditTransactions',
    {},
  );
  const creditTransactions = _get(
    programCreditTransactions,
    'credit_transactions',
    [],
  );
  return {
    currentFlow,
    viewOnlyMode,
    selectedWorkspace,
    fetchingProgramCreditTransactions:
      _get(
        state,
        'apiState.GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.isFetching',
        true,
      ) &&
      !_get(
        state,
        'apiState.GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.isIdle',
        false,
      ),
    fetchedProgramCreditTransactions: _get(
      state,
      'apiState.GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.success',
      true,
    ),
    creditTransactions,
  };
};

const mapDispatchToProps = dispatch => ({
  getCreditTransactionForProgram: payload =>
    dispatch(getCreditTransactionForProgramInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftingProgramRecipientsTable);
